import PropTypes from "prop-types"
import React from "react"

const sectionStyles = {
  padding: `5rem 2rem`,
  margin: `0 auto`,
  maxWidth: `1400px`
};

const subSectionContainer = {
  display: `flex`,
  justifyContent: `space-evenly`,
  flexWrap: `wrap`,
}

const projectContainerStyles = {
  textAlign: `center`,
  width: 355,
  height: 220,
}


const ProjectsSection = ({ projects }) => (
  <section id="projects" style={sectionStyles}>
    <h1 className="section-header">Projects</h1>
    <div style={subSectionContainer}>
      {projects.map((project, index) => (
        <div key={index} style={projectContainerStyles} className="card-container">
          <a href={project.url} className="card" target="_blank" rel="noopener noreferrer">
            <div className="front">
              <img style={{ marginBottom: 0, height: `100%` }} src={project.image} alt={project.title} />
            </div>
            <div className="back">
              <h4>
                {project.title}
              </h4>
              <p>
                {project.description}
              </p>
              <div>
                {project.focus.map(item => item.icon)}
              </div>
            </div>
          </a>
        </div>
      ))}
    </div>
  </section>
)

ProjectsSection.propTypes = {
  projects: PropTypes.arrayOf(PropTypes.shape({
    image: PropTypes.string,
    url: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    focus: PropTypes.arrayOf(PropTypes.shape({
      icon: PropTypes.element,
      tech: PropTypes.string
    }))
  })),
}

ProjectsSection.defaultProps = {
  projects: {},
}

export default ProjectsSection
